import {useNavigate} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import {styled} from "@mui/material/styles";
import {
    BottomNavigationAction,
} from "@mui/material";
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import BottomNavigation from "@mui/material/BottomNavigation";
import Typography from "@mui/material/Typography";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import {AppBar} from "@mui/material";
/* --- Material Outlined Icons --- */
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";              // 💬 for پیام رسان
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined"; // 👤 for پروفایل
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";    // 📦 for محصولات
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";                  // 🗺️ for نقشه
import StoreMallDirectoryOutlinedIcon from "@mui/icons-material/StoreMallDirectoryOutlined";
import Box from "@mui/material/Box"; // 🏬 for فروشگاه‌ها

   const BackButton = () => {
        let navigate = useNavigate();
        return (
            <IconButton
                onClick={() =>navigate(-1)}
                style={{ color: 'black'  }}
                ><ArrowBackIcon/></IconButton>
        );
    }


const StyledAction = styled(BottomNavigationAction)(({ theme }) => ({
    color: "rgba(0,0,0,0.7)",
    fontWeight: "bold",
    transition: "all .25s ease",
    "&.Mui-selected": {
        color: "#9a1111",
        transform: "translateY(-3px)", // subtle lift
    },
    "& .MuiBottomNavigationAction-label": {
        fontSize: 12,
        fontWeight: 700,
        fontFamily: "IRANSans",
        marginTop: 4,
    },
}));

const IconWrapper = ({ children, selected }) => (
    <Box
        sx={{
            width: 35,
            height: 35,
            borderRadius: "50%",
            border: selected
                ? "1.5px solid #9a1111"
                : "1.5px solid rgba(0,0,0,0.5)",
            backgroundColor: selected ? "rgba(154,17,17,0.1)" : "rgb(255,255,255)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.25s ease",
            "&:hover": {
                backgroundColor: selected
                    ? "rgba(154,17,17,0.15)"
                    : "rgba(0,0,0,0.05)",
            },
        }}
    >
        {children}
    </Box>
);

const BottomMenu = () => {
    const [value, setValue] = React.useState("");

    return (
        <BottomNavigation
            elevation={0}
            sx={{
                background: "rgba(238,238,238,0.85)",
                backdropFilter: "blur(10px)",
                borderTop: "1px solid rgba(0,0,0,0.08)",
                borderRadius: "18px 18px 0 0", // ✅ curved top corners
                boxShadow: "0 -4px 14px rgba(0,0,0,0.08)",
                overflow: "hidden",
            }}
            style={{
                width: "100%",
                position: "fixed",
                bottom: 0,
                fontFamily: "IRANSans",
                zIndex: 1200,
            }}
            showLabels
            value={value}
            onChange={(event, newValue) => {
                window.location.assign(newValue);
                setValue(newValue);
            }}
        >
            <StyledAction
                label={<Typography fontSize={10} fontWeight={700}>پیام رسان</Typography>}
                value="messenger/dialogs"
                icon={
                    <IconWrapper selected={value === "messenger/dialogs"}>
                        <ForumOutlinedIcon sx={{ fontSize: 24 }} />
                    </IconWrapper>
                }
            />

            <StyledAction
                label={<Typography fontSize={10} fontWeight={700}>پروفایل</Typography>}
                value="profile"
                icon={
                    <IconWrapper selected={value === "profile"}>
                        <PersonOutlineOutlinedIcon sx={{ fontSize: 24 }} />
                    </IconWrapper>
                }
            />

            <StyledAction
                label={<Typography fontSize={10} fontWeight={700}>محصولات</Typography>}
                value="offers"
                icon={
                    <IconWrapper selected={value === "offers"}>
                        <Inventory2OutlinedIcon sx={{ fontSize: 24 }} />
                    </IconWrapper>
                }
            />

            <StyledAction
                label={<Typography fontSize={10} fontWeight={700}>نقشه</Typography>}
                value="market-map"
                icon={
                    <IconWrapper selected={value === "market-map"}>
                        <MapOutlinedIcon sx={{ fontSize: 24 }} />
                    </IconWrapper>
                }
            />

            <StyledAction
                label={<Typography fontSize={10} fontWeight={700}>فروشگاه‌ها</Typography>}
                value="/"
                icon={
                    <IconWrapper selected={value === "/"}>
                        <StoreMallDirectoryOutlinedIcon sx={{ fontSize: 24 }} />
                    </IconWrapper>
                }
            />
        </BottomNavigation>
    );
};


export {BackButton,BottomMenu}




